const DEFAULT_ROUTE_PREFIX = "/";

const normalizeRoutePrefix = (value) => {
  const rawValue = (value || "").trim();

  if (!rawValue || rawValue === "/") {
    return DEFAULT_ROUTE_PREFIX;
  }

  const withLeadingSlash = rawValue.startsWith("/") ? rawValue : `/${rawValue}`;
  const withoutTrailingSlash = withLeadingSlash.replace(/\/+$/, "");

  return withoutTrailingSlash || DEFAULT_ROUTE_PREFIX;
};

const normalizePathname = (value) => {
  const rawValue = (value || "").trim();

  if (!rawValue || rawValue === "/") {
    return "/";
  }

  const withLeadingSlash = rawValue.startsWith("/") ? rawValue : `/${rawValue}`;
  return withLeadingSlash.replace(/\/+$/, "");
};

export const ROUTE_PREFIX = normalizeRoutePrefix(process.env.REACT_APP_ROUTE_PREFIX);

export const withRoutePrefix = (pathname = "/") => {
  const normalizedPathname = normalizePathname(pathname);

  if (ROUTE_PREFIX === "/") {
    return normalizedPathname;
  }

  if (normalizedPathname === "/") {
    return ROUTE_PREFIX;
  }

  return `${ROUTE_PREFIX}${normalizedPathname}`;
};

export const getAppUrl = (pathname = "/") => `${window.location.origin}${withRoutePrefix(pathname)}`;
